<template>
  <div class="registration-header">
    <div class="container">
      <ul class="nav nav-tabs">
        <li v-for="(tab, index) in tabs"
            v-bind:class="{ active: currentRouteString === tab.route }">
          <a>
            <span class="stepNumber">{{index + 1}}</span>
            <span class="stepName"><span>{{tab.name}}</span></span>
            <span><i class="fa fa-check fa-lg" v-if="index === 0"></i></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'registration-header',
    data () {
      return {
        tabs: [
          { name: 'Validate Membership', route: 'MemberValidation' },
          { name: 'Create Your Login', route: 'CreateProfile' }
        ],
        currentRouteName: ''
      }
    },
    computed: {
      currentRouteString () {
        return this.$route.name.replace(/Mobile+/i, '')
      }
    }
  }

</script>

<style lang="scss" scoped="true">
  @import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';

  .registration-header {

    background-color: #D5D2CA;
    padding-left: 0;

    .container {

      @media (max-width: $screen-sm-min) {

        width: 100%;

      }

    }

    .nav-tabs {
      border-bottom: 0;
      justify-content: center;
      padding: 0;

      @media (max-width: $screen-sm-min) {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
      }

      @media (min-width: $screen-sm-min) {

        padding-left: 2%;
        padding-right: 10%;

      }

      @media (min-width: $screen-md-min) {
        padding-left: 1%;
        padding-right: 15%;

      }

      > li {

        margin: 0;
        background-color: #EEEEEE !important;
        @media (max-width: $screen-sm-min) {
          flex: 1;
        }
        width: 33%;

        > a {

          height: 100%;
          flex-direction: row;
          display: flex;
          justify-content: center;
          border-radius: 0;
          border: 0;
          color: #a1a3a5;
          margin: 0;
          border-right: 1px solid #ffffff;
          display: flex;
          padding: 20px 10px !important;

          @media (min-width: $screen-sm-min) {

            padding: 20px;

          }

          .stepNumber {

            border: 2px solid #D5D2CA;
            padding: 4px;
            border-radius: 50px;
            font-size: 2rem;
            width: 38px;
            height: 38px;
            min-width: 38px;
            flex: 0;

          }

          .stepName {

            text-align: left;
            line-height: 36px;
            margin: auto 10px;

            span {

              display: inline-block;
              vertical-align: middle;
              line-height: 1.4em;

            }

          }

          i {

            display: initial;
            line-height: 38px;
            margin-left: -10px;

            @media (min-width: $screen-sm-min) {

              margin-left: 0;

            }

          }

        }

        &.active {

          > a {

            &, &:hover, &:focus {

              color: #ffffff;
              border-top: 0;
              border-left: 0;
              border-bottom: 0;
              border-color: #ffffff;
              background-color: #EA1929 !important;

            }

            i {

              display: none;

            }

          }

        }

      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/RegistrationHeader.vue